import React from 'react';
import './TestimonialBanner.css';

const TestimonialBanner = () => {
  // Testimonial data
  const testimonials = [
    { text: "1 in 5 Americans will develop skin cancer by the age of 70", author: "Skin Cancer Foundation" },
    { text: "Daily sunscreen users on average showed 24% less skin aging", author: "Annals of Internal Medicine" },
    { text: "Having 5 or more sunburns doubles your risk of melanoma.", author: "Skin Cancer Foundation" },
    { text: "Easy to use and the sunscreen quality is fantastic. No more greasy hands!", author: "— Carlos R., Beach Visitor" },
    { text: "Melanoma accounts for 71% of all skin cancer deaths", author: "Impact Melanoma" },
  ];

  return (
    <div className="testimonial-banner">
      <div className="testimonial-track">
        {testimonials.concat(testimonials).map((testimonial, index) => (
          <div key={index} className="testimonial-item">
            <p className="testimonial-text">{testimonial.text}</p>
            <span className="testimonial-author">{testimonial.author}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TestimonialBanner; 